import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Column } from '@simplywallst/ui-core';

export const HorizontalRule = styled('hr')`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
export const Heading = styled('h4')`
  ${({ theme }) => theme.typography.largeStrong}
`;
export const Container = styled('div')`
  padding-bottom: ${({ theme }) => theme.x4space}rem;
`;

export const CountryIso = styled('abbr')`
  text-decoration: none;
`;

export const SplitColumn = styled(Column)`
  padding-bottom: ${({ theme }) => theme.x3spacePx}px;
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  &:first-child {
    padding-right: ${({ theme }) => theme.x2spacePx}px;
    ${media.smDown`
      padding-right: 0;
    `}
  }
  &:last-child {
    padding-left: ${({ theme }) => theme.x2spacePx}px;
    ${media.smDown`
      padding-left: 0;
      margin-top: 0;
    `}
  }
`;
